import { apiClient } from "../core/apiClient";
import { buildUrlWithParams } from "../core/utils/urlUtils";
import { NOTIFICATION_ENDPOINTS } from "./endpoints";
import type {
  NotificationsResponse,
  MarkNotificationsAsWatchedRequest,
} from "./interfaces";

/**
 * Получение списка уведомлений пользователя
 * Требует авторизации
 *
 * @param userId - ID пользователя
 * @param page - номер страницы
 * @param pageSize - размер страницы
 * @returns список уведомлений
 */
export async function getNotifications(
  userId: string,
  page: number = 1,
  pageSize: number = 20,
): Promise<NotificationsResponse> {
  const url = buildUrlWithParams(
    NOTIFICATION_ENDPOINTS.getUserNotifications(userId),
    {
      page,
      pageSize,
    },
  );

  return apiClient<NotificationsResponse>(url, {
    method: "GET",
    requiresAuth: true,
  });
}

/**
 * Отметить уведомления как просмотренные
 * Требует авторизации
 *
 * @param notificationIds - массив ID уведомлений для отметки
 */
export async function markAsWatched(notificationIds: string[]): Promise<void> {
  const payload: MarkNotificationsAsWatchedRequest = {
    notificationIds,
  };

  return apiClient<void>(NOTIFICATION_ENDPOINTS.markAsWatched, {
    method: "PATCH",
    body: JSON.stringify(payload),
    requiresAuth: true,
  });
}
